import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { InscricaoModel } from '../models';
import { platformBrowserDynamicTesting } from '@angular/platform-browser-dynamic/testing';

@Injectable({
  providedIn: 'root',
})
export class InscricaoService {
  context = '/inscricoes';
  constructor(private apiService: ApiService) {}

  add(inscricao: any): Observable<any> {
    return this.apiService.post(this.context, inscricao);
  }

  carregarComprovativo(data: any, anexo: File): Observable<any> {
    var body = new FormData();
    body.append('comprovativo', anexo);
    body.append('pagamentoInput', JSON.stringify(data));

    return this.apiService.put(
      `${this.context}/${data.id}/inscricao-comprovativo`,
      body
    );
  }

  getAll(params: HttpParams): Observable<any> {
    return this.apiService.get(this.context, params);
  }

  getById(id: number): Observable<any> {
    return this.apiService.get(`${this.context}/${id}`);
  }

  delete(id: number) {
    return this.apiService.delete(`${this.context}/${id}`);
  }
}
